import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2442_8667)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M14.625 5.625H3.375C3.27554 5.625 3.18016 5.66451 3.10984 5.73484C3.03951 5.80516 3 5.90054 3 6V16.5C3 16.8978 3.15804 17.2794 3.43934 17.5607C3.72064 17.842 4.10218 18 4.5 18H13.5C13.8978 18 14.2794 17.842 14.5607 17.5607C14.842 17.2794 15 16.8978 15 16.5V6C15 5.90054 14.9605 5.80516 14.8902 5.73484C14.8198 5.66451 14.7245 5.625 14.625 5.625ZM7.6875 15.375C7.6875 15.5242 7.62824 15.6673 7.52275 15.7727C7.41726 15.8782 7.27418 15.9375 7.125 15.9375C6.97582 15.9375 6.83274 15.8782 6.72725 15.7727C6.62176 15.6673 6.5625 15.5242 6.5625 15.375V8.625C6.5625 8.47582 6.62176 8.33274 6.72725 8.22725C6.83274 8.12176 6.97582 8.0625 7.125 8.0625C7.27418 8.0625 7.41726 8.12176 7.52275 8.22725C7.62824 8.33274 7.6875 8.47582 7.6875 8.625V15.375ZM11.4375 15.375C11.4375 15.5242 11.3782 15.6673 11.2727 15.7727C11.1673 15.8782 11.0242 15.9375 10.875 15.9375C10.7258 15.9375 10.5827 15.8782 10.4773 15.7727C10.3718 15.6673 10.3125 15.5242 10.3125 15.375V8.625C10.3125 8.47582 10.3718 8.33274 10.4773 8.22725C10.5827 8.12176 10.7258 8.0625 10.875 8.0625C11.0242 8.0625 11.1673 8.12176 11.2727 8.22725C11.3782 8.33274 11.4375 8.47582 11.4375 8.625V15.375Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16.5 3H12.9375C12.8878 3 12.8401 2.98025 12.8049 2.94508C12.7698 2.90992 12.75 2.86223 12.75 2.8125V1.875C12.75 1.37772 12.5525 0.900805 12.2008 0.549175C11.8492 0.197544 11.3723 0 10.875 0L7.125 0C6.62772 0 6.15081 0.197544 5.79917 0.549175C5.44754 0.900805 5.25 1.37772 5.25 1.875V2.8125C5.25 2.86223 5.23025 2.90992 5.19508 2.94508C5.15992 2.98025 5.11223 3 5.0625 3H1.5C1.30109 3 1.11032 3.07902 0.96967 3.21967C0.829018 3.36032 0.75 3.55109 0.75 3.75C0.75 3.94891 0.829018 4.13968 0.96967 4.28033C1.11032 4.42098 1.30109 4.5 1.5 4.5H16.5C16.6989 4.5 16.8897 4.42098 17.0303 4.28033C17.171 4.13968 17.25 3.94891 17.25 3.75C17.25 3.55109 17.171 3.36032 17.0303 3.21967C16.8897 3.07902 16.6989 3 16.5 3ZM6.75 2.8125V1.875C6.75 1.77554 6.78951 1.68016 6.85983 1.60984C6.93016 1.53951 7.02554 1.5 7.125 1.5H10.875C10.9745 1.5 11.0698 1.53951 11.1402 1.60984C11.2105 1.68016 11.25 1.77554 11.25 1.875V2.8125C11.25 2.86223 11.2302 2.90992 11.1951 2.94508C11.1599 2.98025 11.1122 3 11.0625 3H6.9375C6.88777 3 6.84008 2.98025 6.80492 2.94508C6.76975 2.90992 6.75 2.86223 6.75 2.8125Z",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = { id: "clip0_2442_8667" }
const _hoisted_4 = ["width", "height"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'deleteIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  size: {
    type: Number as PropType<number>,
    default: 18,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _hoisted_2,
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", _hoisted_3, [
        _createElementVNode("rect", {
          width: __props.size,
          height: __props.size,
          fill: "white"
        }, null, 8, _hoisted_4)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})